import { render } from "./BusinessContext.vue?vue&type=template&id=2512674c&scoped=true"
import script from "./BusinessContext.vue?vue&type=script&lang=js"
export * from "./BusinessContext.vue?vue&type=script&lang=js"

import "./BusinessContext.vue?vue&type=style&index=0&id=2512674c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2512674c"]])

export default __exports__